import { API_QUERY_PARAMS } from '@/types';
import type {
  CreateFormTemplateTagPayload,
  FormTemplateDTO,
  FormTemplateTagDTO,
  FormTemplatesListResponse,
  GetFormTemplatesParams,
  SaveFormTemplateDraftPayload,
  UpdateFormTemplatePayload,
} from '@/types/formsTemplates';
import { ApiService } from './api.service';

class FormsTemplatesService extends ApiService {
  public async getFormTemplateTags(): Promise<FormTemplateTagDTO[]> {
    const response = await this.get<FormTemplateTagDTO[]>('/api/v1/admin/form/templates/tags');
    return response.data;
  }

  public async createFormTemplateTag(payload: CreateFormTemplateTagPayload): Promise<FormTemplateTagDTO> {
    const response = await this.post<FormTemplateTagDTO>('/api/v1/admin/form/templates/tags', payload);
    return response.data;
  }

  public async deleteFormTemplateTag(id: string): Promise<void> {
    await this.delete(`/api/v1/admin/form/templates/tags/${id}`);
  }

  public async getFormTemplates(params: GetFormTemplatesParams = {}): Promise<FormTemplatesListResponse> {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append(API_QUERY_PARAMS.STATUS, params.status);
    if (params.cursor) queryParams.append(API_QUERY_PARAMS.CURSOR, params.cursor);
    if (params.limit) queryParams.append(API_QUERY_PARAMS.LIMIT, params.limit.toString());
    if (params.sortBy) queryParams.append(API_QUERY_PARAMS.SORT_BY, params.sortBy);
    if (params.sortOrder) queryParams.append(API_QUERY_PARAMS.SORT_ORDER, params.sortOrder);
    const query = queryParams.toString();
    const url = `/api/v1/admin/form/templates${query ? `?${query}` : ''}`;
    const response = await this.get<FormTemplatesListResponse>(url);
    return response.data;
  }

  public async getFormTemplateById(id: string): Promise<FormTemplateDTO> {
    const response = await this.get<FormTemplateDTO>(`/api/v1/admin/form/templates/${id}`);
    return response.data;
  }

  public async saveFormTemplateDraft(payload: SaveFormTemplateDraftPayload): Promise<FormTemplateDTO> {
    const response = await this.post<FormTemplateDTO>('/api/v1/admin/form/templates/draft', payload);
    return response.data;
  }

  public async updateFormTemplate(id: string, payload: UpdateFormTemplatePayload): Promise<void> {
    await this.put(`/api/v1/admin/form/templates/${id}`, payload);
  }

  public async deleteFormTemplate(id: string): Promise<void> {
    await this.delete(`/api/v1/admin/form/templates/${id}`);
  }
}

export const formsTemplatesService = new FormsTemplatesService();
